import React from 'react';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { I18nFormatter } from '../../../../utils/I18n/I18n';
import UserStore from '../../../../stores/UserStore';

const accountEntries = (state) => state.publisherAccountEntries.list;

export const getHeaderNames = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().dataTable.headers;
        return [
            staticNames.id,
            staticNames.date,
            staticNames.commission,
            staticNames.reason
        ];
    }
);

export const getAccountEntries = createSelector(
    accountEntries,
    (accountEntries = []) => {
        let list = [];

        accountEntries.forEach((item) => {
            let diffAmount = -1*(parseInt(item.sum.amount) > 0 ? '+' + item.sum.amount : item.sum.amount);
            const payoutNames = UserStore.getTranslation().payoutPage;

            list.push({
                id:(
                    <div>
                        <span className="wrap__desktop">{item.id}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.id}</div>
                            <div className="row-value">{item.id}</div>
                        </div>
                    </div>
                ),
                createdAt: (
                    <div>
                        <span className="wrap__desktop">{I18nFormatter.fullDateTime(item.created_at)}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.date}</div>
                            <div className="row-value">{I18nFormatter.fullDateTime(item.created_at)}</div>
                        </div>
                    </div>
                ),
                difference: (
                    <div>
                        <span className="wrap__desktop">{_getColorNumber(item.sum.amount, I18nFormatter.currency(diffAmount, item.sum.currency))}</span>
                        <div className="wrap__mobile">
                            <div className="row-title">{payoutNames.commission}</div>
                            <div className="row-value">{_getColorNumber(item.sum.amount, I18nFormatter.currency(diffAmount, item.sum.currency))}</div>
                        </div>
                    </div>
                ),
                source: (
                    <div>
                        <span className="wrap__desktop">{_getSourceAccountEntry(item.source)}</span>
                        <div className="wrap__mobile">
                            <div className="row-value">{_getSourceAccountEntry(item.source)}</div>
                        </div>
                    </div>
                )
            });
        });

        return list;
    }
);

export const getSelectOptions = createSelector(
    () => {
        const accountEntryReason = UserStore.getTranslation().accountEntryReason;
        return [
            {
                title: accountEntryReason.all,
                value: 'all'
            },{
                title: accountEntryReason.conversion,
                value: 'conversion'
            }
        ];
    }
);

const _getSourceAccountEntry = (source) => {
    const accountEntryReason = UserStore.getTranslation().accountEntryReason;
    let value = accountEntryReason[source.value];

    if (source.value === 'conversion' && source.parameters.id) {
        value = <Link to={`/conversion/${source.parameters.id}`}>{value}</Link>;
    } else if (source.value === 'payout_new' && source.parameters.id) {
        value = <Link to={`/payout/${source.parameters.id}`}>{value}</Link>;
    } else if (source.value === 'payout_canceled' && source.parameters.id) {
        value = <Link to={`/payout/${source.parameters.id}`}>{value}</Link>;
    } else if (source.value === 'custom' && source.parameters.reason) {
        value = `${value}: ${source.parameters.reason}`;
    } else if (source.value === 'custom_with_goal' && source.parameters.reason) {
        value = `${value}: ${source.parameters.reason}`;
    } else if (source.value === 'payout_cap_automatic_correction' && source.parameters.reason) {
        value = `${value}: ${source.parameters.reason}`;
    }

    return value;
};

const _getColorNumber = (number, value) => {
    return <span className={number < 0 ? 'green' : 'red'}>{value}</span>
};
